import { PageHeader } from '@lmc/ui-kit'
import styled from 'styled-components'
import { useState } from 'react'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import DashboardFilters from '../DashboardFilters/DashboardFilters'
import DashboardBody from '../DashboardBody/DashboardBody'
import { MonitoringReportResponse } from '@lmc/ts-common'
import { generateApiUrl } from '../../utils'
import { RangeValue } from 'types/shared'

export type FilterValues = {
  rangePicker: RangeValue<dayjs.Dayjs>
  residents?: string[]
  riskAssessment?: string | null
  categories?: string[]
  categoryItems?: string[]
  loggedBy?: string[]
  locations?: string[]
  statuses?: string[]
  severities?: string[]
  resultedIn?: string[]
}

const initialFiltersValue: FilterValues = {
  rangePicker: [dayjs().subtract(2, 'week').startOf('day'), dayjs()],
  residents: [],
  loggedBy: [],
}

export type MonitoringReportProps = {
  helpUrl: string
  title: string
  description: string
  reportingId: string
  aggregation: string
}

const MonitoringReport = ({
  helpUrl,
  title,
  description,
  reportingId,
  aggregation,
}: MonitoringReportProps) => {
  const [filterParams, setFilterParams] =
    useState<FilterValues>(initialFiltersValue)
  const url = generateApiUrl(filterParams, reportingId, aggregation)

  const { isLoading, data } = useQuery<MonitoringReportResponse>(url, () =>
    getJSON({ url })
  )

  return (
    <Wrapper>
      <PageHeader
        title={<TitleContainer>{title}</TitleContainer>}
        subtitle={description}
        moreInfoLink={helpUrl}
      />
      <DashboardFilters
        onChange={setFilterParams}
        value={filterParams}
        reportingId={reportingId}
      />
      <DashboardBody
        data={data}
        reportingId={reportingId}
        filterParams={filterParams}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 1480px;
  padding: 24px 0 50px;
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.mediaQueries?.tabletDown} {
    padding: 24px;
  }

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin: 0;
  }
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export default MonitoringReport
